import * as React from 'react';
import {useToken} from 'native-base';

interface IconProps {
  width?: string;
  height?: string;
  color: string;
}

export default ({width, height, color}: IconProps) => {
  const [fillColor] = useToken('colors', [color]);

  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox="0 0 1280.000000 1247.000000"
      preserveAspectRatio="xMidYMid meet">
      <g
        transform="translate(0.000000,1247.000000) scale(0.100000,-0.100000)"
        fill={fillColor}
        stroke="none">
        <path
          d="M6175 12456 c-127 -26 -246 -77 -380 -164 -53 -35 -336 -312 -1175
 -1151 -2382 -2383 -4318 -4328 -4357 -4376 -112 -139 -190 -293 -234 -461 -19
 -72 -23 -116 -24 -234 0 -189 28 -307 111 -470 114 -224 302 -356 584 -414
 155 -31 316 -36 1283 -36 l968 0 24 -26 c14 -15 30 -43 36 -63 19 -64 25 -231
 14 -406 -6 -106 -10 -803 -10 -1860 0 -1592 1 -1696 18 -1795 107 -616 530
 -929 1337 -990 178 -13 3616 -14 3835 0 405 25 657 80 879 191 102 52 152 86
 232 162 134 125 223 289 263 482 5 28 13 64 17 80 4 17 10 950 13 2075 6 2019
 6 2045 26 2084 44 87 91 97 385 79 880 -53 1445 -66 1701 -38 395 42 657 144
 842 329 139 140 219 343 234 593 15 273 -75 517 -292 788 -73 91 -222 244
 -416 425 -84 79 -1148 1136 -2364 2349 -1215 1212 -2257 2247 -2315 2299 -331
 300 -599 466 -857 532 -103 27 -285 34 -378 16z"
        />
      </g>
    </svg>
  );
};
